import { Center, Group, Loader, Stack, Text } from '@mantine/core';
import { useMutation } from '@tanstack/react-query';
import { useMediaQuery } from '@mantine/hooks';
import Card from 'components/Card';
import { useAuth } from 'hooks/useAuth';
import React, { useEffect, useState } from 'react';
import { HiOutlineBookmark } from 'react-icons/hi';
import { beelajarService } from 'services/beelajar/beelajar.service';

interface BeelajarLMSSectionProps {
  beelajarId: string;
}

const BeelajarLMSSection = ({ beelajarId }: BeelajarLMSSectionProps) => {
  const { profile } = useAuth();
  const [embedUrl, setEmbedUrl] = useState<string>('');

  const isMobile = useMediaQuery('(max-width: 576px)');
  const isTablet = useMediaQuery('(min-width: 577px) and (max-width: 992px)');
  const isLaptop = useMediaQuery('(min-width: 993px)');

  const beelajarLogin = useMutation({
    mutationFn: beelajarService.loginBeelajarService,
    onSuccess: (res) => {
      const loginUrl = res?.data?.loginurl;
      if (loginUrl) {
        const baseUrl = (process.env.REACT_APP_BEELAJAR_URL || '').replace(
          '/webservice/rest/server.php',
          ''
        );
        const newEmbedUrl = `${baseUrl}/local/api_dacum20/embedded/view-course.php?id=${beelajarId}`;
        setEmbedUrl(`${loginUrl}&wantsurl=${encodeURIComponent(newEmbedUrl)}`);
      }
    },
    onError: (err) => {
      // eslint-disable-next-line no-console
      console.error('error login beelajar lms', err);
    }
  });

  useEffect(() => {
    if ((profile?.beelajarEmail || profile?.adminEmail) && beelajarId) {
      handleBeelajarLogin();
    }
  }, [profile?.adminEmail, profile?.beelajarEmail, beelajarId]);

  const handleBeelajarLogin = async () => {
    if (!profile) return;
    await beelajarLogin.mutateAsync({ email: profile?.beelajarEmail || profile.adminEmail });
  };

  const getResponsiveWidth = () => {
    if (isMobile) return '100%';
    if (isTablet) return '100%';
    if (isLaptop) return '938px';
    return '100%';
  };

  return (
    <Card>
      <Stack gap={16}>
        <Group gap={8}>
          <HiOutlineBookmark />
          <Text c={'dark'} fw={700}>
            Activities
          </Text>
        </Group>
        {beelajarId && embedUrl ? (
          beelajarLogin.isPending ? (
            <Center>
              <Loader />
            </Center>
          ) : (
            <iframe
              src={embedUrl}
              width={getResponsiveWidth()}
              height={isMobile ? '500' : '700'}
              title='Embedded Content'
              style={{
                border: '1px solid #ccc',
                borderRadius: '10px',
                maxWidth: '100%'
              }}
            />
          )
        ) : (
          <Center py={40}>
            <Text fz={14} fw={500}>
              No activities available
            </Text>
          </Center>
        )}
      </Stack>
    </Card>
  );
};

export default BeelajarLMSSection;
